import type { Tag } from "@hulahoop/ui";
import type { ComponentProps } from "react";
import type { Language } from "@/domain/common";
import { DEFAULT_EXPORT_FORMAT, type ExportFormat } from "@/domain/export";
import {
  type HubStatus,
  INVESTOR_STATUSES,
  INVESTOR_TYPES,
  type InvestorSortField,
  type InvestorStatus,
  type InvestorType,
} from "@/domain/investor";

type TagTone = NonNullable<ComponentProps<typeof Tag>["variant"]>;

export { INVESTOR_STATUSES, INVESTOR_TYPES };

export const INVESTOR_TYPE_TONE: Record<InvestorType, TagTone> = {
  individual: "sage",
  company: "blue-dark",
};

export const HUB_VARIANT: Record<HubStatus, "outline" | "warning" | "success"> = {
  none: "outline",
  pending: "warning",
  active: "success",
};

export const LANGUAGES: readonly Language[] = ["es", "ca", "en"];

export type InvestorToggleVerb = "restore" | "deactivate" | "activate";

export const investorToggleVerb = (status: InvestorStatus): InvestorToggleVerb =>
  status === "archived" ? "restore" : status === "active" ? "deactivate" : "activate";

export const investorToggleTarget = (status: InvestorStatus): InvestorStatus =>
  status === "active" ? "inactive" : "active";

export type InvestorSortKey = "name" | "investments" | "available" | "created";

export const INVESTOR_SORT_FIELD: Record<InvestorSortKey, InvestorSortField> = {
  name: "name",
  investments: "number_investments",
  available: "money.available",
  created: "created_at",
};

const INVESTOR_EXPORT_COLUMN: Partial<Record<string, string>> = {
  email: "email",
  city: "city",
  potential: "potential_investment_amount",
  status: "status",
};

const EXPORT_FORMATS: readonly ExportFormat[] = ["csv", "xlsx", "json"];

export const toInvestorExportFormat = (format: string): ExportFormat =>
  EXPORT_FORMATS.find((candidate) => candidate === format) ?? DEFAULT_EXPORT_FORMAT;

export const investorExportColumnOf = (key: string) => INVESTOR_EXPORT_COLUMN[key];

export const INVESTOR_EXPORT_BASE = ["display_name", "type"];
